<div class="p-4">
    <div class="container">
    <router-outlet></router-outlet>
            
        </div>
    </div>
    
    